import React, { useEffect, useState } from "react";
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import BannerSection from "./components/BannerSection";
import BrandSection from "./components/BrandSection";
import CarSection from "./components/CarSection";
import PricingSection from "./components/PricingSection";
import FunFactSection from "./components/FunFactSection";
import WhyChooseSection from "./components/WhyChooseSection";
import CarShopSection from "./components/CarShopSection";
import Testimonials from "./components/Testimonials";
import BlogSection from "./components/BlogSection";
import PurchaseSellSection from "./components/PurchaseSellSection";
import { useLocation, useNavigate } from "react-router-dom";
import BannerSectionsecond from "./components/BannerSectionsecond";
import axiosInstance from "../../axiosInstance";
import axios from "axios";

const Home = () => {
  const [check, setcheck] = useState(false);
  const location = useLocation();
  const [loading,setLoading] = useState(false)
  const [error,setError] = useState("")
  const [limit,setLimit] = useState(8)
  const [inventories,setInventories] = useState([])
  const [selectedtype,setSelectedType] = useState("")
  const [types,setTypes] = useState(["SUV", "Sedan", "Hatchback", "Convertible"])
  const navigate = useNavigate()
  const getAllInventory = async(page,limit,selectedtype) => {
    try {
      setLoading(true)
      setError("")
      const response = await axiosInstance.get(`/api/public/getAllInventory`,{
        params:{page,limit,category:selectedtype}
      })
      setLimit(response?.data?.limit);
      setInventories(response?.data?.data);
    } catch (error) {
       if (axios.isAxiosError(error)) {
        if (error.response) {
          const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
          setError(msg);
        }
        else if (error.request) {
          setError("No response from server. Please check your internet connection.");
        }
        else {
          setError(error.message || "Unexpected error occurred.");
        }
      } else {
        setError("An unexpected error occurred.");
      }
    } finally{
      setLoading(false)
    }
  }
  
  // const getAllTypes = async() => {
  //   try {
  //     setLoading(true)
  //     setError("")
  //     const response = await axiosInstance.get(`/api/public/getAllTypes`)
  //     setTypes(response?.data?.data);
  //     if(response?.data?.data[0]) setSelectedType(response?.data?.data[0])
  //   } catch (error) {
  //      if (axios.isAxiosError(error)) {
  //       if (error.response) {
  //         const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
  //         setError(msg);
  //       }
  //       else if (error.request) {
  //         setError("No response from server. Please check your internet connection.");
  //       }
  //       else {
  //         setError(error.message || "Unexpected error occurred.");
  //       }
  //     } else {
  //       setError("An unexpected error occurred.");
  //     }
  //   } finally{
  //     setLoading(false)
  //   }
  // }
  useEffect(()=>{
    console.log(selectedtype);
    
    getAllInventory(1,limit,selectedtype)
  },[selectedtype]) 
  // useEffect(()=>{
  //   getAllTypes()
  // },[navigate])
  return (
    <div>
      <div className="boxcar-wrapper">
        <Header preclass="home"    check={check} setcheck={setcheck} />
        {/* <BannerSection /> */}
        <BannerSectionsecond loading={loading} error = {error} inventories = {inventories} selectedtype={selectedtype} setSelectedType = {setSelectedType} types= {types} getAllInventory={getAllInventory}/>
        {/* <BrandSection /> */}
        <CarSection />
        <PricingSection />
        <FunFactSection />
        <WhyChooseSection />
        {/* <CarShopSection /> */}
        <Testimonials />
        {/* <BlogSection /> */}
        <PurchaseSellSection />
        <Footer />
      </div>

      {check && (
        <div
          onClick={() => setcheck(false)}
          className="mm-wrapper__blocker mm-slideout"
        ></div>
      )}
    </div>
  );
};

export default Home;
